import { numberToAbbrev } from '@libs/numbers';

// TODO add options
// FIXME: удалить, использовать утилиту numberToAbbrev напрямую
export function useFormatNumber(number?: number) {
  return numberToAbbrev(number);
}
